module.exports = __webpack_public_path__ + "img/product7.98de5131.png";